import { httpClient } from '../httpClient';

export const scannerApi = {
  scan: (url) =>
    httpClient.post('/website-scanner/scan', { url }),

  getHistory: () =>
    httpClient.get('/website-scanner/history'),

  getScanDetail: (id) =>
    httpClient.get(`/website-scanner/history/${id}`),

  downloadReport: (id, lang) =>
    httpClient.get(`/website-scanner/history/${id}/report.pdf`, {
      params: { lang },
      responseType: 'blob',
    }),

  batchScan: (urls) =>
    httpClient.post('/website-scanner/batch', { urls }),

  getMonitors: () =>
    httpClient.get('/website-scanner/monitored'),

  registerMonitor: (body) =>
    httpClient.post('/website-scanner/monitored', body),

  deleteScan: (id) =>
    httpClient.delete(`/website-scanner/history/${id}`),

  bulkDeleteScans: (ids) =>
    httpClient.delete('/website-scanner/history', { data: { ids } }),

  deleteMonitor: (id) =>
    httpClient.delete(`/website-scanner/monitored/${id}`),

  getCommandCenter: () =>
    httpClient.get('/website-scanner/command-center'),

  getSiteReport: (hostname, from, to) =>
    httpClient.get(`/website-scanner/reports/site/${encodeURIComponent(hostname)}`, { params: { from, to } }),
};
